import TextField from '@app/src/components/Ui/TextField'
import useCurrentProviderTypeName from '@app/src/hooks/currentProviderTypeName'
import { isNotPositiveWholeNumber } from '@app/src/utils/helpers'
import React from 'react'
import { Control, Controller } from 'react-hook-form'
import { useIntl } from 'react-intl'
import { PROGRESS_TRACKER_QUESTION_KEYS, ProgressTrackerFormType } from './CreateProgressTrackerModal'

const TotalCompaniesCountField: React.FC<{
  control: Control<ProgressTrackerFormType>
  totalCompaniesCount: number | undefined
}> = ({ control, totalCompaniesCount }) => {
  const { formatMessage } = useIntl()
  const [localError, setLocalError] = React.useState<string | null>(null)
  const providerType = useCurrentProviderTypeName({ isPlural: true })

  return (
    <Controller
      name={PROGRESS_TRACKER_QUESTION_KEYS.TOTAL_COMPANIES_COUNT}
      control={control}
      render={({ onChange, onBlur, value, name }) => (
        <TextField
          label={formatMessage(
            { id: 'schemas.progressTracker.createNewModal.numberOfProviders' },
            {
              providerType,
            },
          )}
          type="number"
          onChange={e => {
            const inputValue = e.target.value
            onChange(inputValue ? Number(inputValue) : null)
          }}
          onBlur={e => {
            onBlur()
            const inputValue = value
            const errorMessage = formatMessage({ id: 'error.mustBePositiveWholeNumber' })

            if (inputValue !== null && inputValue !== undefined && isNotPositiveWholeNumber(inputValue)) {
              setLocalError(errorMessage)
            } else {
              setLocalError(null)
            }
          }}
          value={value}
          name={name}
          defaultValue={totalCompaniesCount}
          helperText={
            localError || formatMessage({ id: 'schemas.progressTracker.createNewModal.numberOfProvidersDescription' })
          }
          error={Boolean(localError)}
        />
      )}
    />
  )
}

export default TotalCompaniesCountField
